// stock-analysis-report-excel.js
import React, { useState } from "react";
import {
  Layout,
  Breadcrumb,
  Button,
  Table,
  Row,
  Spin,
  Card,
  Col,
} from "antd";
import {
  FileExcelOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { Link } from "react-router-dom";
import { APPBACKGROUND_COLOR, MAINAPIURL } from "../../appsettings";
import { AlertError } from "../../usableclasses";
import Headerdiv from "../../layout/header";
import Footerdiv from "../../layout/footer";
import { handleStockAnalysisExcelExport } from "./stock-analysis-report-excel";

const { Content } = Layout;

const columns = [
  {
    title: "Code",
    dataIndex: "productCode",
    key: "productCode",
    align: "center",
  },
  {
    title: "Name",
    dataIndex: "productName",
    key: "productName",
    align: "left",
  },
  {
    title: "BP",
    dataIndex: "bpCount",
    key: "bpCount",
    align: "right",
  },
  {
    title: "BV",
    dataIndex: "bvValue",
    key: "bvValue",
    align: "right",
  },
  {
    title: "CP",
    dataIndex: "cpValue",
    key: "cpValue",
    align: "right",
  },
  {
    title: "Cost",
    dataIndex: "costPrice",
    key: "costPrice",
    align: "right",
  },
  {
    title: "Category",
    dataIndex: "category",
    key: "category",
    align: "center",
  },
  {
    title: "Total Stock",
    dataIndex: "totalStock",
    key: "totalStock",
    align: "right",
  },
  {
    title: "Sold Units",
    dataIndex: "soldUnits",
    key: "soldUnits",
    align: "right",
  },
];

const StockAnalysisReport = () => {
  const ApiURL = MAINAPIURL;
  const TOKEN = localStorage.getItem("AUTHCODE");
  const [isLoading, setIsLoading] = useState(false);
  const [stockAnalysisItems, setStockAnalysisItems] = useState([]);

  const fetchStockAnalysisItems = async () => {
    try {
      setIsLoading(true);
      const headers = { SystemAccessToken: TOKEN };
      const response = await axios.get(
        `${ApiURL}/reports/stock/stockanalysis`,
        { headers }
      );
      setStockAnalysisItems(response.data);
    } catch (error) {
      AlertError("Failed to Load Stock Analysis Items");
    } finally {
      setIsLoading(false);
    }
  };

  const handleExcelExport = () => {
    handleStockAnalysisExcelExport(stockAnalysisItems);
  };

  return (
    <Spin spinning={isLoading} tip="Processing...">
      <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
        <Headerdiv />
        <Content style={{ padding: "10px" }}>
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>
              <Link to={"/reports"}>Reports</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Stock Analysis Report</Breadcrumb.Item>
          </Breadcrumb>

          <Card title={<Row justify="space-between" align="middle">
            <Col>Stock Analysis Report</Col>
            <Col>
              <Button
                disabled={stockAnalysisItems.length === 0}
                type="primary"
                icon={<FileExcelOutlined />}
                onClick={handleExcelExport}
                style={{ backgroundColor: "#28a745", borderColor: "#28a745" }}
              >
                Export to Excel
              </Button>
            </Col>
          </Row>} style={{ marginBottom: 20 }}>
            <Row justify="end" style={{ marginBottom: 16 }} gutter={16}>
              <Col>
                <Button
                  type="primary"
                  onClick={fetchStockAnalysisItems}
                  loading={isLoading}
                  icon={<SearchOutlined />}
                >
                  Get Data
                </Button>
              </Col>
            </Row>

            <Table
              columns={columns}
              dataSource={stockAnalysisItems}
              pagination={false}
              bordered
              scroll={{ x: "max-content" }}
              rowKey="productCode"
            />
          </Card>
        </Content>
        <Footerdiv />
      </Layout>
    </Spin>
  );
};

export default StockAnalysisReport;
